<template>
    <div>
        <PageHeader :page="page" :template="'2'" @action="createNew" v-if="!state.loading"/>
        <div class="" v-if="!state.loading">
            <DataTable :tableData="tableData" @view="viewCustomer" @edit="edit" @work_order="workOrder"
            @notes="getNotes" @complaints="showComplaints" @subscription="subscription"/>
        </div>
        <div class="temp-row" v-if="state.loading" style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>
    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm :columns="2"
            :fields="newFields" @submit="addCustomer"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView> 

    
    <ModalView
        :isVisible="state.ViewModal"
        :fixclose="true"
        @close="state.ViewModal = false">
        
        <FormView :columns="2"
            :fields="viewFields" 
            :loading="state.modalLoading" />
    </ModalView> 

    
    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        
        <div v-if="!state.modalLoading">
            <DynamicForm :columns="2"
                :fields="editFields" @submit="editCustomer"
                :submitting="state.submitting" :errors="state.errors"
                :success="state.success" />
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
          </div>
    </ModalView> 

    <ModalView
        :isVisible="state.notesModal"
        :fixclose="true"
        @close="state.notesModal = false">
        <div v-if="!state.modalLoading">
            <div v-if="state.notesview">
                <div class="v-flex align-items-center justify-content-between">
                    <h2>Customer Notes</h2>
                    <span class="btn-primary" @click="addNote">Add Note</span>
                </div>
                <HistoryItem v-for="(item, i) in notes" :key="i" :hitem="item" :action="historyAction" 
                    :class="{inactive: !item.isAuth}" @edit="editNote" @delete="deleteNote"/>
            </div>
            <div v-if="state.createnote">
                <DynamicForm :columns="2"
                    :fields="cnFields" @submit="sendNote"
                    :submitting="state.submitting" :errors="state.errors"
                    :success="state.success" />
            </div>
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
        
    </ModalView>


    <ModalView
        :isVisible="state.editNoteModal"
        :fixclose="true"
        @close="state.editNoteModal = false">
        <div v-if="!state.modalLoading">
            <DynamicForm :columns="2"
                :fields="enFields" @submit="sendNote"
                :submitting="state.submitting" :errors="state.errors"
                :success="state.success" />
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
        
    </ModalView>

    <ModalView
        :isVisible="state.CreateOrderModal"
        :fixclose="true"
        @close="state.CreateOrderModal = false">
        
        <DynamicForm ref="createOrderForm" :columns="1"
            :fields="orderFields" @submit="createOrder"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>

</template>

<script>
import icons from '@/assets/js/icons.js';
import { defineComponent, reactive, ref, onMounted, computed} from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/DataTable.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import FormView from '@/components/FormView.vue';
import ModalView from '@/components/ModalView.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { usePermissions } from '@/composables/usePermissions';
import HistoryItem from '@/components/HistoryItem.vue';

export default defineComponent({
    components:{PageHeader, DataTable,DynamicForm,ModalView,FormView,HistoryItem},
    setup(){
        const store= useStore();
        const system = computed(() => store.state.System.system);
        const router = useRouter();
        const { hasPermission } = usePermissions();
        const createForm=ref(null);
        const createOrderForm=ref(null);
        const state=reactive({CreateModal:false, submitting:false,error:[],success:false,
        loading:true,customer_type:[{label:"Individual",value:"individual"},{label:"Organization",value:"organization"}],
        ViewModal:false,modalLoading:true,editModal:false,notesModal:false,notesview:false,createnote:false,
            activeCustomer:"",editNoteModal:false,CreateOrderModal:false
        });
        const notes=ref([])
        const svgIcons = ref(icons);
        const staff=ref([])
        const packages=ref([])
        const cname=system.value.c;
        const page=ref({title:cname+" List", btn:"Add new",
        desc:"Manage your "+cname+" database with ease. View "+cname+" details, track interactions, and update information"})
        
        var action_label=[icons.view],
        action=["view"]
        if(!hasPermission('Customers List', 'create')){
            page.value.btn="";
        }

        if(hasPermission('Customers List', 'edit')){
            action.push("edit");
            action_label.push(icons.edit)
        }
        action.push("notes");
        action_label.push(icons.note)
        if(hasPermission('CRM', 'view')){
            action.push("complaints");
            action_label.push(icons.complaint)
        }
        const newFields=ref([])


        
        if(system.value.sub){
            newFields.value.push(
                { name: "Add "+cname, number: "1",data: 
                    [
                        { type: 'text', name: 'name', label: 'Name',
                            value: ""  },
                        { type: 'select', name: 'type', label: cname+' Type',
                            value: "",options:state.customer_type  },
                        {type: 'text', name: 'phone', label: 'Phone No.',
                            value: ""},
                        {type: 'text', name: 'email', label: 'Email Address',
                            value: ""},
                        {type: 'text', name: 'address', label: 'Address',
                            value: ""},
                        {type: 'date', name: 'date', label: 'Onboarding Date',
                            value: ""},
                        { type: 'select', name: 'csm', label: system.value.am,
                            value: "",options:staff  }
                    ]
                },
                { name: "Subscription", number: "2", data:
                    [{ type: 'select', name: 'package', label: "Subscription",
                        value: "",options:packages  }
                    ]
                }
            )
        }else{
            newFields.value.push(
                { name: "Add "+cname, number: "1",data: 
                    [
                        { type: 'text', name: 'name', label: 'Name',
                            value: ""  },
                        { type: 'select', name: 'type', label: cname+' Type',
                            value: "",options:state.customer_type  },
                        {type: 'text', name: 'phone', label: 'Phone No.',
                            value: ""},
                        {type: 'text', name: 'email', label: 'Email Address',
                            value: ""},
                        {type: 'text', name: 'address', label: 'Address',
                            value: ""},
                        {type: 'date', name: 'date', label: 'Onboarding Date',
                            value: ""},
                        { type: 'select', name: 'csm', label: system.value.am,
                            value: "",options:staff  }
                    ]
                }
            )
        }

        var historyAction=ref({
            label:[icons.edit,icons.trash],
            action:["Edit","Delete"]
        });

        if(hasPermission('Task Assignment', 'create') || hasPermission('CRM', 'create')){
            action.push("work_order");
            action_label.push(icons.task)
        }
        

        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Name" },
                { label: "Info" },
                { label: "Type" },
                { label: "CSM" }
            ],
            options:{
                label:"Action",
                action_label:action_label,
                action:action
            },
            total:0
        });

        if(system.value.sub){
            tableData.value.columns.push({label:"Package"});   
            if(hasPermission('Subscription', 'view')){
                tableData.value.options.action.push("subscription");
                tableData.value.options.action_label.push(icons.subscription)
            }         
        }

        const viewFields=ref([])
        const editFields=ref([])
        const cnFields=ref([])
        const enFields=ref([])
        const orderFields=ref([])

        
            
        
        function createNew(){
            if(system.value.sub){
                if(system.value.acct_type==""){
                    alert("Office accounting settings not found. Please contact your system administrator to configure accounting settings to continue")
                    return;
                }
            }
            state.success=false;
            state.error=[]
            state.CreateModal=true;
        }

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id,status:msg[set].status};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        onMounted(() => {
            call({
                url:urls.customer,
                data:{startCustomer:""},
                success:(res)=>{
                state.loading=false
                if(res.status){
                    var d=res.msg;
                    staff.value=[];
                        Object.keys(d.staff).forEach(k => {
                        staff.value.push(d.staff[k])
                    })
                    packages.value=[];
                        Object.keys(d.packages).forEach(k => {
                        packages.value.push(d.packages[k])
                    })
                    setTable(d.customers);
                }else{
                    alert(res.msg);
                }
                }
            })
        });

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
            var e=res.msg[key],er="";
            Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
            })
            errors.push(er);
            });
            state.errors=errors;
        }

        function addCustomer(data){
            state.submitting=true;
            state.errors=[];
            data.addCustomer="";
            call({
                url:urls.customer,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg);
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function viewCustomer(i){
            state.modalLoading=true
            state.ViewModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.customer,
                data:{getCustomer:id},
                success:(res)=>{
                state.modalLoading=false;
                if(res.status){
                    viewFields.value.length=0;
                    var c=res.msg.customer;
                    viewFields.value.push(
                        { name: cname+" Info", number: "1",data: 
                            [{ label: 'Name',name: 'name',
                            value: c.name  },
                            {  label: cname+' Type',name: 'type',
                            value: c.type},
                            {label: 'Phone No.',name: 'phone',
                            value: c.phone},
                            {label: 'Email Address',name: 'email',
                            value: c.email},
                            {label: 'Address',name: 'address',
                            value: c.address},
                            {label: 'Onboarding Date',name: 'date',
                            value: c.date},
                            {label: system.value.am, name: 'csm', 
                            value: c.csm_name},
                            ]
                        }
                    );
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function edit(i){
            state.modalLoading=true
            state.editModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.customer,
                data:{getCustomer:id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        editFields.value.length=0;
                        var c=res.msg.customer;
                        var d=res.msg;
                        staff.value=[];
                        Object.keys(d.staff).forEach(k => {
                            staff.value.push(d.staff[k])
                        })
                        editFields.value.push(
                            { name: cname+" Info", number: "1",data: 
                                [{ type: 'text', label: 'Name',name: 'name',
                                value: c.name  },
                                { type: 'select', label: cname+' Type',name: 'type',
                                value: c.type,options:state.customer_type },
                                {type: 'text',label: 'Phone No.',name: 'phone',
                                value: c.phone},
                                {type: 'text',label: 'Email Address',name: 'email',
                                value: c.email},
                                {type: 'text',label: 'Address',name: 'address',
                                value: c.address},
                                {type: 'date', label: 'Onboarding Date',name: 'date',
                                value: c.date},
                                {type: 'select', label: system.value.am, name: 'csm', 
                                value: c.csm,options:staff},
                                {type:"hidden", value:id, name:"id"}
                                ]
                            }
                        );
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        function editCustomer(data){
            state.submitting=true;
            state.errors=[];
            data.editCustomer="";
            call({
                url:urls.customer,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg);
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function getNotes(i){
            state.modalLoading=true
            state.notesModal=true;
            state.notesview=true;
            state.createnote=false;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            state.activeCustomer=id;
            call({
                url:urls.customer,
                data:{getCustomerNotes:id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        notes.value=res.msg;
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function addNote(){
            cnFields.value.push(
                { name: "Add Customer Note", number: "1",data: 
                    [{ type: 'textarea', name: 'note', label: 'Note',
                    value: ""  },
                    { type: 'hidden', name: 'cid', value: state.activeCustomer },
                    ]
                }
            );
            state.notesview=false;
            state.createnote=true;
        }

        function sendNote(data){
            state.submitting=true;
            state.errors=[];
            data.addCustomerNote="";
            call({
                url:urls.customer,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function editNote(item){
            if(!item.isAuth){return;}
            state.modalLoading=true;
            state.editNoteModal=true;
            state.submitting=false;
            state.success=false;
            state.notesModal=false;
            state.errors=[];
            enFields.value.length=0;
            call({
                url:urls.customer,
                data:{editNote:item.id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        enFields.value.push(
                            { name: "Edit Customer Note", number: "1",data: 
                                [{ type: 'textarea', name: 'note', label: 'Note',
                                value: res.msg  },
                                { type: 'hidden', name: 'id', value: item.id },
                                ]
                            }
                        );
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function deleteNote(item){
            if(!item.isAuth){return;}
            var c=confirm("Are you sure you want to delete this note? this cannot be undone!");
            if(!c){return;}
            state.modalLoading=true;
            call({
                url:urls.customer,
                data:{deleteNote:item.id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        notes.value=res.msg;
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function showComplaints(i){
            if(hasPermission('CRM', 'view')){
                var id=tableData.value.rows[i].id
                router.push({ name: 'ccomplaints', params: { customerId: id } });
            }
            
        }

        function subscription(i){
            var id=tableData.value.rows[i].id
            router.push({ name: 'subhistory', params: { customerId: id } });
        }

        function workOrder(i){
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            orderFields.value.length=0;
            orderFields.value.push(
                { name: "Create Work Order", number: "1",data: 
                    [{ type: 'text', name: 'name', label: 'Order Title',
                    value: ""  },
                    { type: 'date', name: 'deadline', label: 'Deadline',
                    value: ""  },
                    { type: 'wysiwyg', name: 'desc', label: 'Description',
                    value: ""  },
                    { type: 'hidden', name: 'cid', value: id},
                    ]
                },
                { name: "Assign Order", number: "2",data: 
                    [{ type: 'select', name: 'assignee_1', label: 'Staff',
                    options:staff}
                    ]
                }
            )
            state.CreateOrderModal =true;
        }

        function createOrder(data){
            state.submitting=true;
            state.errors=[];
            data.createWorkOrder=(orderFields.value.length-1).toString();
            call({
                url:urls.task,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                }else{
                    setErrors(res)
                }
                }
            })
        }


        return{page,icons: svgIcons.value,tableData,state,createForm,viewCustomer,notes,
            newFields,createNew,addCustomer,viewFields,edit,editFields,editCustomer,getNotes,
            cnFields,addNote,sendNote,historyAction,editNote,enFields,deleteNote,
            showComplaints,subscription,orderFields,createOrder,createOrderForm,
            workOrder
        }
    }
});
</script>
<style scoped>
h2, .h2 {
    font-size: 20px; margin: 0;
}
:deep(.inactive .icwrap){display:none}
:deep(.icwrap .trash_ic){stroke:var(--red)}
</style>